import AvgOfFacingBySku from "./AvgOfFacingBySku";
export default AvgOfFacingBySku;
